import React, { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { handleUniNoticeAction } from 'actions/uninotice/commonUniNoticeActions'
import { toggleInlineNoticeAction } from 'actions/uninotice/toggleInlineNoticeAction'
import {
  saveUniNoticeClickStatisticsAction,
  saveUniNoticeStatisticsAction,
  UniNoticeStatistics,
} from 'actions/uninotice/uniNoticeAction'
import {
  UniNoticeActionId,
  UniNoticePayload,
} from 'api/uninotice/uninotice.types'
import { UniNoticeId } from 'api/uninotice/uniNoticeApi'
import { CommonNoticeView } from 'components/uninotice/CommonNoticeView'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { uniNoticeReducer } from 'reducers/uniNoticeReducer'

import { UniNoticeData } from './UniNotice.constants'
import { profileNotFoundNoticeId } from './uniNoticeIdList'

export interface UniNoticeInlineProps {
  className?: string
  viewWithoutBorder?: boolean
  shouldDeactivateOnClick?: boolean
  watchedNotice: UniNoticeId
}

export const UniNoticeInline: FC<UniNoticeInlineProps> = ({
  className,
  viewWithoutBorder,
  shouldDeactivateOnClick,
  watchedNotice,
}) => {
  useReducersInsert({ uniNoticeReducer: uniNoticeReducer })
  const dispatch = useDispatch()
  const { collection, activeInline } = useShallowEqualSelector(
    ({ uniNoticeReducer: { collection, activeInline } }) => ({
      collection,
      activeInline,
    })
  )

  const currentUniNotice = collection[watchedNotice]
  const isActive = activeInline[watchedNotice]
  useEffect(() => {
    if (currentUniNotice) {
      dispatch(
        saveUniNoticeStatisticsAction(
          currentUniNotice.noticeId,
          UniNoticeStatistics.view
        )
      )
    }
  }, [currentUniNotice])

  const handlePrimaryClick = () => {
    const { payload: rawPayload, noticeId, type } = currentUniNotice
    const payload = rawPayload as UniNoticePayload

    const { actionId, data } = payload.actionBtn.action
    const { display } = payload.appearance!

    dispatch(handleUniNoticeAction(actionId, noticeId, data!, type, display))
    if (shouldDeactivateOnClick) {
      dispatch(toggleInlineNoticeAction(noticeId, false))
    }
    dispatch(saveUniNoticeClickStatisticsAction(noticeId, actionId))
  }

  const handleSecondaryClick = (
    actionId: UniNoticeActionId,
    data: UniNoticeData
  ) => {
    const { payload, type } = currentUniNotice
    const { display } = (payload as UniNoticePayload).appearance!

    dispatch(handleUniNoticeAction(actionId, noticeId, data, type, display))
  }

  if (!isActive || !currentUniNotice) {
    return null
  }

  const { noticeId } = currentUniNotice
  const withNavigation = [profileNotFoundNoticeId].includes(noticeId)

  return (
    <CommonNoticeView
      className={className}
      notice={currentUniNotice}
      onActionClick={handlePrimaryClick}
      onSecondaryClick={handleSecondaryClick}
      viewWithoutBorder={viewWithoutBorder}
      withNavigation={withNavigation}
    />
  )
}
